import { render, staticRenderFns } from "./download-manual-icon.vue?vue&type=template&id=55dfac1a"
import script from "./download-manual-icon.vue?vue&type=script&lang=js"
export * from "./download-manual-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports